export enum Provinces {
  BritishColumbia = 1,
  Ontario = 2,
  Manitoba = 3,
  NewBrunswick = 4,
  Quebec = 5,
  Other = 99
}
